import type { ReactionTypes } from '@assembly-web/services';
import { Emoji } from 'emoji-mart';

import { classNames } from '../../../DesignSystem/Utils/classNames';

export type ReactionEmoji = {
  name: string;
  value: string;
  type: ReactionTypes;
  displayName?: string;
};

type ReactionsEmojiProps = {
  reaction: ReactionEmoji;
  size: number;
  count: number;
  isSelected: boolean;
};

export const ReactionEmoji = ({
  reaction,
  size,
  count,
  isSelected,
}: ReactionsEmojiProps) => {
  return (
    <div className="flex h-fit items-center justify-center gap-1 py-1">
      <Emoji emoji={reaction.name} size={size} />
      <span
        className={classNames('text-sm', {
          'text-gray-8': !isSelected,
          'text-primary-6': isSelected,
        })}
      >
        {count}
      </span>
    </div>
  );
};
